var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_16112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8523 6.85714H7.68182C7.21166 6.85714 6.76076 6.67653 6.42831 6.35504C6.09586 6.03355 5.90909 5.59751 5.90909 5.14286V0.142857C5.90909 0.104969 5.89353 0.0686328 5.86582 0.0418419C5.83812 0.015051 5.80054 0 5.76136 0H2.36364C1.73676 0 1.13556 0.240816 0.692293 0.66947C0.249025 1.09812 0 1.67951 0 2.28571V13.7143C0 14.3205 0.249025 14.9019 0.692293 15.3305C1.13556 15.7592 1.73676 16 2.36364 16H10.6364C11.2632 16 11.8644 15.7592 12.3077 15.3305C12.751 14.9019 13 14.3205 13 13.7143V7C13 6.96211 12.9844 6.92578 12.9567 6.89898C12.929 6.87219 12.8915 6.85714 12.8523 6.85714Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5279 5.59239L7.21676 0.456318C7.20643 0.446389 7.1933 0.439634 7.17901 0.436903C7.16472 0.434172 7.14992 0.435586 7.13646 0.440967C7.123 0.446349 7.11149 0.455458 7.10337 0.467149C7.09525 0.47884 7.09088 0.492592 7.09082 0.506676V5.14275C7.09082 5.2943 7.15308 5.43964 7.26389 5.54681C7.37471 5.65397 7.52501 5.71418 7.68173 5.71418H12.4758C12.4904 5.71412 12.5046 5.7099 12.5167 5.70204C12.5288 5.69419 12.5382 5.68306 12.5438 5.67004C12.5494 5.65703 12.5508 5.64271 12.548 5.62889C12.5452 5.61508 12.5382 5.60238 12.5279 5.59239Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_16112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.9ed4aac5ddecaff694e8641614906c4b.svg";
export { ForwardRef as ReactComponent };